import { createBrowserRouter, RouteObject } from 'react-router-dom';
import App from '@/App';
import { Login, Register, PasswordResetRequest, PasswordResetConfirm, ConnectWhoop, WhoopOAuthCallback, WhoopSimple, WhoopSimpleCallback, ConnectTerra, ConnectWearable } from '@/auth';
import { PersonalDashboard } from '@/components';
import UnifiedDashboard from '@/components/UnifiedDashboard';
import { CoachDashboard } from '@/components/coach-dashboard';
import { AdminDashboard } from '@/components/admin-dashboard';
import { TeamInfo } from '@/components/team-information';
import { AthleteDetail } from '@/components/athlete-detail';
import SettingsPage from '@/components/settings/SettingsPage';
import { PageviewTracker } from '@/components/shared/PageviewTracker';
import { AthleteCheckIn } from '@/components/sessions';
import Landing from '@landing/Landing';
import ServicesPage from '@landing/30-services/30-ServicesPage';
import PricingPage from '@landing/40-pricing/40-PricingPage';
import AboutPage from '@landing/20-about/20-AboutPage';
import ContactPage from '@landing/50-contact/50-ContactPage';

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <>
                <PageviewTracker />
                <App />
            </>
        ),
        children: [
            {
                index: true,
                element: <Landing />,
            },
            {
                path: 'services',
                element: <ServicesPage />,
            },
            {
                path: 'pricing',
                element: <PricingPage />,
            },
            {
                path: 'about',
                element: <AboutPage />,
            },
            {
                path: 'contact',
                element: <ContactPage />,
            },
            {
                path: 'login',
                element: <Login />,
            },
            {
                path: 'register',
                element: <Register />,
            },
            {
                path: 'password-reset',
                element: <PasswordResetRequest />,
            },
            {
                path: 'reset-password/:uid/:token',
                element: <PasswordResetConfirm />,
            },
            {
                path: 'dashboard',
                element: <UnifiedDashboard />,
            },
            {
                path: 'coach-dashboard',
                element: <CoachDashboard />,
            },
            {
                path: 'admin-dashboard',
                element: <AdminDashboard />,
            },
            {
                path: 'team-information',
                element: <TeamInfo />,
            },
            {
                path: 'settings',
                element: <SettingsPage />,
            },
            {
                path: 'athlete/:teamId/:athleteId',
                element: <AthleteDetail />,
            },
            {
                path: 'connect-whoop',
                element: <ConnectWhoop />,
            },
            {
                path: 'connect-whoop-callback',
                element: <WhoopOAuthCallback />,
            },
            {
                path: 'connect-whoop-simple',
                element: <WhoopSimple />,
            },
            {
                path: 'connect-whoop-simple-callback',
                element: <WhoopSimpleCallback />,
            },
            {
                path: 'connect-terra',
                element: <ConnectTerra />,
            },
            {
                path: 'connect-wearable',
                element: <ConnectWearable />,
            },
            // Catapult Vector connection removed - not implementing yet
        ],
    },
] as RouteObject[]); 